import { getApiUrl, useDevAuthEnabled } from '@/config/clientPortalConfig'
import { useAuthStore } from '@/stores/useAuthStore'

async function sleep(ms: number) {
  return new Promise((resolve) => setTimeout(resolve, ms))
}

async function fetchWithRetry(url: string, options: RequestInit, retries = 3): Promise<Response> {
  for (var attempt = 0; attempt < retries; attempt++) {
    var response = await fetch(url, options)
    if (response.ok || response.status === 400 || response.status === 401 || response.status === 403 || response.status === 404) {
      return response
    }
    if (attempt < retries - 1) {
      await sleep(Math.pow(2, attempt) * 1000)
    }
  }
  return fetch(url, options)
}

export async function useFetchApi(path: string, options?: RequestInit) {
  var headers = new Headers(options?.headers)
  var hasFormDataBody = options?.body instanceof FormData
  if (options?.body != null && !hasFormDataBody && !headers.has('Content-Type')) {
    headers.set('Content-Type', 'application/json')
  }
  if (!headers.has('api-version')) {
    headers.set('api-version', '3.0')
  }
  var authStore = useAuthStore()
  if (!useDevAuthEnabled()) {
    var token = await authStore.getAccessToken()
    if (token) {
      headers.set('Authorization', `Bearer ${token}`)
    }
  }
  var url = new URL(path, getApiUrl()).toString()
  return fetchWithRetry(url, { ...options, headers })
}

export async function fetchJson<T>(path: string, options?: RequestInit): Promise<T> {
  var response = await useFetchApi(path, options)
  if (!response.ok) {
    throw response
  }
  return response.json() as Promise<T>
}

export async function fetchPublicJson<T>(path: string, options?: RequestInit): Promise<T> {
  var headers = new Headers(options?.headers)
  if (options?.body != null && !(options.body instanceof FormData) && !headers.has('Content-Type')) {
    headers.set('Content-Type', 'application/json')
  }
  headers.set('api-version', '3.0')
  var url = new URL(path, getApiUrl()).toString()
  var response = await fetchWithRetry(url, { ...options, headers })
  if (!response.ok) {
    throw response
  }
  return response.json() as Promise<T>
}
